import { Box, Button, TextField, useMediaQuery, useTheme, MenuItem } from "@mui/material";
import { Formik } from "formik";
import * as yup from "yup";
import { useAllowanceTypesList } from "api/hooks/humanResource";
import { useSelector } from "react-redux";
import { requester } from "api/pesabackend";

const AllowanceTypeSchema = yup.object().shape({
  related_allowance_type: yup.string().required("required"),
  frequency: yup.string().required("required"),
  amount: yup.number().required("required"),
});



const EmployeeAllowanceForm = (props) => {
  const pageType = props.formType;
  let { employeeId, editData } = props;
  const userId = useSelector((state) => state.authReducer.user.userId);
  const business_branch_id = useSelector((state) => state.authReducer.business_branch_id);
  const { palette } = useTheme();
  const isNonMobile = useMediaQuery("(min-width:600px)");
  const isNew = pageType === "create";
  const isEdit = pageType === "edit";
  const {allowanceTypeList} = useAllowanceTypesList(1, business_branch_id);

  const initialValuesAllowanceType = isNew ? {
    related_allowance_type: "",
    amount: 0,
    frequency: "",
  } : {
    related_allowance_type: editData.related_allowance_type.id,
    amount: editData.amount,
    frequency: editData.frequency,
  };

  const saveAllowanceType = async (values, onSubmitProps) => {
    values.added_by = userId;
    values.related_employee = employeeId;

    const savedResponse = await requester.post(`/human_resource/employees/payroll?payroll_type=allowance`,  JSON.stringify(values));

    if (savedResponse.data.status === 201) {
      onSubmitProps.resetForm();
      props.setIsSuccess(true);
      props.setNewEmployeeAllowanceData(true);
      props.setOpen(false);
    }
  };

  const editAllowanceType = async (values, onSubmitProps) => {
    const savedResponse = await requester.post(`/human_resource/employees/payroll/edit/${editData.id}`, JSON.stringify(values));

    if (savedResponse.data.status === 201) {
      onSubmitProps.resetForm();
      props.setIsSuccess(true);
      props.setNewEmployeeAllowanceData(true);
      props.setOpen(false);
    }
  };

  const handleFormSubmit = async (values, onSubmitProps) => {
    if (isNew) await saveAllowanceType(values, onSubmitProps);
    if (isEdit) await editAllowanceType(values, onSubmitProps);
  };

  return (
    <Formik
      onSubmit={handleFormSubmit}
      initialValues={initialValuesAllowanceType}
      validationSchema={AllowanceTypeSchema}
    >
      {({
        values,
        errors,
        touched,
        handleBlur,
        handleChange,
        handleSubmit,
      isSubmitting,
      }) => (
        <form onSubmit={handleSubmit}>
          <Box
            display="grid"
            gap="30px"
            gridTemplateColumns="repeat(4, minmax(0, 1fr))"
            sx={{
              "& > div": { gridColumn: isNonMobile ? undefined : "span 4" },
            }}
          >
            <TextField
              label="Allowance Type"
              onBlur={handleBlur}
              onChange={handleChange}
              select
              disabled={isEdit}
              value={values.related_allowance_type}
              name="related_allowance_type"
              error={
                Boolean(touched.related_allowance_type) &&
                Boolean(errors.related_allowance_type)
              }
              helperText={
                touched.related_allowance_type && errors.related_allowance_type
              }
              sx={{ gridColumn: "span 2" }}
            >
              {allowanceTypeList.map((row, index) => {
                return (
                  <MenuItem
                    key={index}
                    value={row.id}
                    selected={
                      row.id === values.related_allowance_type ? true : false
                    }
                  >
                    {row.allowance_name}
                  </MenuItem>
                );
              })}
            </TextField>

            <TextField
              label="Amount"
              onBlur={handleBlur}
              onChange={handleChange}
              type="number"
              value={values.amount}
              name="amount"
              error={Boolean(touched.amount) && Boolean(errors.amount)}
              helperText={touched.amount && errors.amount}
              sx={{ gridColumn: "span 2" }}
            />

            <TextField
              label="Frequency"
              onBlur={handleBlur}
              select
              defaultValue={"MONTHLY"}
              onChange={handleChange}
              value={values.frequency}
              name="frequency"
              error={Boolean(touched.frequency) && Boolean(errors.frequency)}
              helperText={touched.frequency && errors.frequency}
              sx={{ gridColumn: "span 2" }}
            >
              <MenuItem value="DAILY">DAILY</MenuItem>
              <MenuItem value="WEEKLY">WEEKLY</MenuItem>
              <MenuItem value="BI-WEEKLY">BI-WEEKLY</MenuItem>
              <MenuItem value="MONTHLY">MONTHLY</MenuItem>
              <MenuItem value="ANNUALLY">ANNUALLY</MenuItem>
            </TextField>
          </Box>

          {/* BUTTONS */}
          <Box>
            <Button
              fullWidth
              type="submit"
              disabled={isSubmitting}
              sx={{
                m: "1rem 0",
                p: "1rem",
                backgroundColor: palette.primary.main,
                color: palette.background.alt,
                "&:hover": { color: palette.primary.main },
              }}
            >
              Save
            </Button>
          </Box>
        </form>
      )}
    </Formik>
  );
};

export default EmployeeAllowanceForm;
